// ----------------------------------------------------------------------

export default function TextField(theme) {
    return {
        MuiOutlinedInput: {
            styleOverrides: {
                root:{
                    borderRadius:"10px"
                }
            }
        }
    }
}
